module.exports = __webpack_public_path__ + "static/media/stir-splash-photo-mobi.2298bf43.jpg";